import { useMemo } from 'react'

import { AppVariant } from '@common/enums'

import { ACTIVITY_LOG_ROUTES } from '../layout.const'

interface UseLayoutRouteStateParams {
  pathname?: string | null
}

export function useLayoutRouteState({ pathname }: UseLayoutRouteStateParams) {
  return useMemo(() => {
    const pathSegments = pathname?.split('/') ?? []

    const isSettingsRoute = pathSegments.includes('settings')

    return {
      isVisionRoute: pathSegments.includes(AppVariant.VISION),
      isSettingsRoute,
      isProjectSettingsRoute: isSettingsRoute && pathSegments.includes('project'),
      isActivityLogRoute: ACTIVITY_LOG_ROUTES.some((route) => pathname?.includes(route)),
      isServiceMapRoute: pathSegments.includes('service-map'),
    }
  }, [pathname])
}
